import { render } from "./PendingApprovals.vue?vue&type=template&id=06fb3298"
import script from "./PendingApprovals.vue?vue&type=script&lang=js"
export * from "./PendingApprovals.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__